// extracted by mini-css-extract-plugin
export default {"Menu_wrapper":"Menu_Menu_wrapper__HlAOQ"};